export const SELECT_HOLDING_SUBSCRIPTION_FORM = "selectHoldingSubscriptionForm";
export const SEND_USER_VERIFICATION_FORM = "sendUserVerificationForm";